export default __webpack_public_path__ + "static/media/truck3.06ed7f3e.svg";